import React from 'react';

const AllAdminNews = () => {
  return (
    <>
      <h1>All admin news</h1>
    </>
  );
};

export default AllAdminNews;